import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

const mutateUpdateAnnouncement = async ({
  id,
  data,
}: {
  id: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${GET_COMMUNITIES}/${id}/news-settings`, data);
};

const useUpdateAnnouncementMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateAnnouncement,
    ...queryParams,
  });

export default useUpdateAnnouncementMutation;
